import { LinearProgress, Typography, linearProgressClasses, styled } from '@mui/material';

export const LinearProgressStyle = styled(LinearProgress)(({ theme }) => ({
  height: 6,
  borderRadius: 10,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: '#cccccc',
  },
  [`& .${linearProgressClasses.bar}`]: {
    backgroundColor: theme.palette.warning.main,
  },
}));

export const CommentStyle = styled(Typography)<{ isShowAll: boolean; lineClamp: string }>(
  ({ isShowAll, lineClamp }) => ({
    overflow: 'hidden',
    display: isShowAll ? 'block' : '-webkit-box',
    '-webkit-line-clamp': lineClamp,
    '-webkit-box-orient': 'vertical',
    overflowWrap: 'anywhere',
  }),
);
